<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-18 17:33:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/orderresult/components/ResDet/index.vue
-->
<template>
  <div class="con border_bottom1px">
    <div class="succ_det">
      <img
        src="@/assets/order/icon_result_succ@2x.png"
        alt=""
        class="succ_icon"
      />
      <span class="font24 font_weight600 line_height_32 colo0 succ_font"
        >支付成功</span
      >
    </div>
    <div class="font12 font_weight400 line_height_17 colo087 order_money">
      实付{{ getUserOrder.total | currency(false) }}
    </div>
    <div class="succ_btn font14 font_weight400 line_height_20 colo087">
      <div class="btn_item mr_r" @click="goOrderDetail">查看订单</div>
      <div class="btn_item" @click="goHome">返回首页</div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  },
  methods: {
    goHome() {
      this.$emit("goHome");
    },
    goOrderDetail() {
      this.$emit("goOrderDetail");
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  margin: 0 12px;
  padding-bottom: 12px;
  .succ_det {
    padding-top: 20px;
    .succ_icon {
      width: 28px;
      vertical-align: middle;
      margin-right: 3px;
    }
    .succ_font {
      vertical-align: middle;
    }
  }
  .order_money {
    margin-top: 8px;
  }
  .succ_btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .btn_item {
      padding: 5px 17px;
      border-radius: 15px;
      border: 1px solid #000000;
    }
    .mr_r {
      margin-right: 27px;
    }
  }
}
</style>
